import {
  CREATE_FRESHDESK_TICKET,
  FETCH_FRESHDESK_CONVERSATIONS,
  FETCH_FRESHDESK_TICKETS,
  FETCH_FRESHDESK_USER_ID,
  UPDATE_FRESHDESK_CONVERSATIONS,
  UPDATE_FRESHDESK_TICKET,
} from '../actions/types';

const initialState = {
  freshdeskTickets: [],
  conversations: [],
  freshdeskUserId: null,
};

export default function freshdeskReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FRESHDESK_TICKETS:
      return { ...state, freshdeskTickets: action.payload };
    case CREATE_FRESHDESK_TICKET:
      return { ...state, freshdeskTickets: [action.payload, ...state.freshdeskTickets] };
    case UPDATE_FRESHDESK_TICKET:
      const updatedTicket = action.payload[0];
      const index = state.freshdeskTickets.findIndex(ticket => ticket.id === updatedTicket.id);
      const updatedTickets = [...state.freshdeskTickets];
      if (index !== -1) {
        updatedTickets[index] = {
          ...updatedTickets[index],
          description: updatedTicket.description,
          status: updatedTicket.status,
        };
      }
      return { ...state, freshdeskTickets: updatedTickets };
    case FETCH_FRESHDESK_CONVERSATIONS: {
      const { ticketId, data } = action.payload;
      const nonPrivateConversations = conversationsData => conversationsData.filter(entry => !entry.private);
      const nonPrivateData = nonPrivateConversations(data);
      const currentConversations = state.conversations.filter(conversation => conversation.ticketId !== ticketId);
      const currentConversation = nonPrivateData.length ? [{ ticketId, data: nonPrivateData }] : [];
      return {
        ...state,
        conversations: [
          ...currentConversations,
          ...currentConversation,
        ],
      };
    }
    case UPDATE_FRESHDESK_CONVERSATIONS: {
      const { ticketId, comment } = action.payload;
      const appendCommentToConversation = (conversation) => ({
        ...conversation,
        data: [...(conversation.data || []), comment],
      });
  
      const updatedConversations = state.conversations.map(conversation =>
        conversation.ticketId === ticketId ? appendCommentToConversation(conversation) : conversation,
      );
  
      if (!updatedConversations.some(conversation => conversation.ticketId === ticketId)) {
        updatedConversations.push({
          ticketId:
          ticketId,
          data: [comment],
        });
      }
      return { ...state, conversations: updatedConversations };
    }
    case FETCH_FRESHDESK_USER_ID:
      return { ...state, freshdeskUserId: action.payload };
    default:
      return state;
  }
}

